import {
  watchlistTranslationsBundle,
  Translator,
} from "@fds/wm-typescript-poc-waap-localization-translations";
import { EgbWatchlistStoreModuleFactory } from "@/overrides/EgbWatchlistStoreModuleFactory";
import { watchlistPlugin } from "@fds/wm-typescript-poc-waap-library";
import { formatters } from "@/helpers/formatters";
import {
  LogLevel,
  ConsoleLogger,
  Mdg2Client,
} from "@fds/wm-typescript-mdg2-client";
import store from "@/store";
import { WidgetConfig } from "./index";

const logger = new ConsoleLogger("Watchlist");
logger.setLevel(LogLevel.SILENT);
const fixedTranslations = { ...watchlistTranslationsBundle };
fixedTranslations.de.watchlistSelector.label = "Wählen Sie die Watchlist";
fixedTranslations.de.watchlist.addPosition = "Position hinzufügen";
fixedTranslations.de.watchlist.createWatchlistAction = "Watchlist hinzufügen";
fixedTranslations.de.watchlist.editWatchlistAction = "Watchlist bearbeiten";
fixedTranslations.de.watchlist.deleteWatchlistAction = "Watchlist löschen";
fixedTranslations.de.watchlist.deletePosition = "Position löschen";
fixedTranslations.de.watchlistPositionAdd.noSelectedPositions =
  "Derzeit sind keine Position zum Hinzufügen zur Watchlist ausgewählt.";

export default (mdg2Client: Mdg2Client) => {
  return <WidgetConfig>{
    name: watchlistPlugin,
    options: {
      translator: new Translator({
        translations: fixedTranslations,
      }),
      storeModule: new EgbWatchlistStoreModuleFactory({
        mdg2Client,
        logger,
        store,
        options: {
          endpointConfiguration: {
            defaultVersion: "v4",
          },
        },
      }),
      ...formatters,
      logger,
    },
  };
};
